export default __webpack_public_path__ + "static/media/cherryb.acb5dcfd.gif";